import { Form } from 'react-bootstrap';
import { handleInputChange } from '../Field';

const Zip = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
}) => {
  const handleChange = (e) => {
    const eTmp = { ...e };
    if (e.target.value.toString().length > 6) {
      const v = e.target.value.toString().split('');
      v.pop();
      eTmp.target.value = Number(v.join(''));
      handleInputChange(eTmp, onChange);
    } else {
      handleInputChange(eTmp, onChange);
    }
  };

  return (
    <div className={className}>
      <Form.Label className={labelClassName}>{label}</Form.Label>
      <div>
        <Form.Control
          name={name}
          type="number"
          id="inputZip"
          className={inputClassName}
          value={value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Zip;
